import React from 'react';
import PropTypes from 'prop-types';
import { Bar } from 'react-chartjs-2';
import { Translate, I18n } from 'react-redux-i18n';
import { getReportChartOptions, REPORT_CHART_COLORS } from '../../reportChartOptions';

const Trade = ({ chartData, loading, year, month }) => {
  const labels = chartData?.labels || [
    'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic',
  ];
  const stock = chartData?.stock || [];
  const option = chartData?.option || [];

  const data = {
    labels,
    datasets: [
      {
        label: 'Stock',
        backgroundColor: REPORT_CHART_COLORS.stock,
        data: stock,
      },
      {
        label: 'Option',
        backgroundColor: REPORT_CHART_COLORS.option,
        data: option,
      },
    ],
  };

  const meta =
    chartData?.granularity === 'day' && month
      ? I18n.t('report_chart_trades_daily', { year, month: monthLabel(month) })
      : I18n.t('report_chart_trades_monthly', { year });

  return (
    <div className="report-panel">
      <div className="report-panel-header">
        <h3 className="report-panel-title">
          <Translate value="report_trades" />
        </h3>
        <span className="report-panel-meta">{meta}</span>
      </div>
      <div className="report-panel-body">
        {loading ? (
          <div className="report-loading">
            <Translate value="report_loading" />
          </div>
        ) : (
          <div className="report-chart-wrap">
            <Bar data={data} options={getReportChartOptions()} />
          </div>
        )}
      </div>
    </div>
  );
};

function monthLabel(m) {
  const names = [
    '', 'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic',
  ];
  return names[Number(m)] || m;
}

Trade.propTypes = {
  chartData: PropTypes.object,
  loading: PropTypes.bool,
  year: PropTypes.number,
  month: PropTypes.string,
};

export default Trade;
